export function getDocumentTop() {
  var scrollTop = 0,
    bodyScrollTop = 0,
    documentScrollTop = 0;

  if (document.body) {
    bodyScrollTop = document.body.scrollTop;
  }

  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop;
  }

  scrollTop =
    bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
  return Math.floor(scrollTop);
}

export function getWindowHeight() {
  var windowHeight = 0;
  if (document.compatMode == "CSS1Compat") {
    windowHeight = document.documentElement.clientHeight;
  } else {
    windowHeight = document.body.clientHeight;
  }
  return Math.floor(windowHeight);
}

export function getScrollHeight() {
  var scrollHeight = 0,
    bodyScrollHeight = 0,
    documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  scrollHeight =
    bodyScrollHeight - documentScrollHeight > 0
      ? bodyScrollHeight
      : documentScrollHeight;
  return Math.floor(scrollHeight);
}

export function scrollFix(num) {
  return Math.floor(num / 100);
}

export function cacheIssue(issueId, data) {
  sessionStorage.setItem(`issuecache_${issueId}`, JSON.stringify(data));
}

export function getCacheIssue(issueId) {
  return JSON.parse(sessionStorage.getItem(`issuecache_${issueId}`));
}
